module.exports = __webpack_public_path__ + "img/101a-02.prt.62b58db3.jpg";